import React, { useState, useEffect } from "react";

import Navbar from '../Components/Navbar'
import img2 from '../Assets/ca.png'
import img3 from '../Assets/image1.png'
import Footer from '../Components/Footer'
import { Link } from 'react-router-dom'
import { toast } from "react-toastify";
import { Create_Api } from "../Api_Url";
import GetSeodata from "../Components/GetSeodata";
function Contact() {
  const [activeTab, setActiveTab] = useState(1);
  const handleTabChange = (tabIndex) => {
    setActiveTab(tabIndex);
  };
  const [activeTab2, setActiveTab2] = useState(1);
  const handleTabChange2 = (tabIndex) => {
    setActiveTab2(tabIndex);
  };

  const [Name, setName] = useState('');
  const [Email, setEmail] = useState('');
  const [Number, setNumber] = useState('');
  const [Address, setAddress] = useState('');
  const [Message, setMessage] = useState('');
  const [IsUploading, setIsUploading] = useState(false);

  const ContactUs = async (e) => {
    e.preventDefault();
    if (!Name) return toast.error('Name is required!');
    if (!Email) return toast.error('Email is required!');
    if (!Number) return toast.error('Number is required!');
    if (!Address) return toast.error('Address is required!');
    if (!Message) return toast.error('Message is required!');
    try {
      let data = {
        Name,
        Email,
        Number,
        Address,
        Message
      }
      setIsUploading(true)
      const response = await Create_Api(`api/admin/CreateContactUsForm`, data)
      toast.success(response?.message);
      setName('')
      setEmail('')
      setNumber('')
      setAddress('')
      setMessage('')
      setIsUploading(false)
    } catch (error) {
      setIsUploading(false)
      toast.error(error?.response?.data?.message);
      console.log(error)
    }
  }


  return (
    <>
      <Navbar />
      <GetSeodata PageName={'contact'} />
      <div className='about-div'>
        <h1>CONTACT US</h1>
        <p><i>Home - Contact Us</i></p>

      </div>
      <div className='havequestion'>
        <h1>HAVE A QUESTION? <br />CONTACT US!</h1>
        <p>A dynamic startup agency, is dedicated to fueling the aspirations of emerging businesses.<br /> We specialize in crafting captivating online identities</p>

      </div>
      <br />
      <br />
      <div className='contact-form'>
        <div className='contact-form-left'>
          <div className="loc-icon">
            <div>
              <div className="oc-icon-border">
                <i class="bi bi-geo-alt-fill"></i>
              </div>
            </div>
            <div>
              <h3>Location</h3>
              <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District,
                Phuket 83000, Thailand</p>
            </div>
          </div>
          <br />
          <div className="loc-icon">
            <div>
              <div className="oc-icon-border">
                <i className="bi bi-telephone-fill"></i>
              </div>
            </div>
            <div>
              <h3>Contact Details</h3>
              <p>
                <a href="tel:+66930711160" style={{ textDecoration: "none", color: "inherit" }}>
                  +66 930711160
                </a>
              </p>
            </div>
          </div>
          <br />
          <div className="loc-icon">
            <div>
              <div className="oc-icon-border">
                <i className="bi bi-envelope-fill"></i>
              </div>
            </div>
            <div>
              <h3>Mail</h3>
              <p>
                <a
                  href="https://mail.google.com/mail/?view=cm&to=b2b@expleradmc.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  b2b@expleradmc.com
                </a>
              </p>
            </div>
          </div>
          <br />
        </div>
        <div className='contact-form-right'>
          <div className='contact-form-right-from'>
            <h3>Get In Touch</h3>
            <br />
            <div className='inps'>
              <div className='inp'>
                <label>Your Name</label>
                <input
                  placeholder='Your Name'
                  value={Name}
                  onChange={(e) => { setName(e.target.value) }}
                />
              </div>
            </div>
            <br />
            <div className='inps'>
              <div className='inp'>
                <label>Your Email</label>
                <input
                  placeholder='Your Email'
                  value={Email}
                  onChange={(e) => { setEmail(e.target.value) }}
                />
              </div>
              <div className='inp'>
                <label>Your Phone</label>
                <input
                  placeholder='Your Phone'
                  value={Number}
                  onChange={(e) => { setNumber(e.target.value) }}
                />
              </div>
            </div>
            <br />
            <div className='inps'>
              <div className='inp'>
                <label>Your Address</label>
                <input
                  placeholder='Your Address'
                  value={Address}
                  onChange={(e) => { setAddress(e.target.value) }}
                />
              </div>
            </div>
            <br />
            <div className='inps'>
              <div className='inp'>
                <label>Message</label>
                <textarea
                  placeholder='Write Message'
                  value={Message}
                  onChange={(e) => { setMessage(e.target.value) }}
                />
              </div>
            </div>
            <br />
            <div className='inps'>
              <div className='inp'>
                <button onClick={(e) => { ContactUs(e) }}>{IsUploading ? "Please Wait" : "Send Message"}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <br />
      <div>
        <br />
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", gap: "20px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              gap: "20px",
              textAlign: "center",
            }}
          >
            {[
              { title: "MICE & Corporate Events", email: "mice@expleradmc.com" },
              { title: "Weddings & Yacht Rentals", email: "elite@expleradmc.com" },
              { title: "Hotel Contracting Only", email: "contracting@explera.co.th" },
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: "10px",
                  width: "280px",
                }}
              >
                <div
                  className="oc-icon-border"
                  style={{
                    border: "2px solid green",
                    borderRadius: "50%",
                    padding: "10px",
                  }}
                >
                  <i className="bi bi-envelope-fill" style={{ color: "green", fontSize: "24px" }}></i>
                </div>
                <h3 style={{ fontSize: "18px", margin: "0" }}>{item?.title}</h3>
                <p style={{ margin: "0" }}>
                  <a
                    href={`https://mail.google.com/mail/?view=cm&to=${item?.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none", color: "black", fontWeight: "500" }}
                  >
                    {item?.email}
                  </a>
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className='map'>
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3951.69934940521!2d98.38967447448962!3d7.9264374052733615!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3050319a82743699%3A0x974691d01c3b9c!2sBest%20thailand%20DMC%20-%20Explera%20Vacations%20Co%20Ltd%20-%20Explera.co.th!5e0!3m2!1sen!2sin!4v1737099160971!5m2!1sen!2sin" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <br />
      <br />
      <br />
      <br />
      <div className="heading-cnter">
        <h3>OUR OFFICES</h3>
      </div>
      <div className="tab-container">
        <div className="tabs">
          <button
            className={activeTab === 1 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(1)}>
            India Office
          </button>
          <button
            className={activeTab === 2 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(2)}>
            Combaodia  Office

          </button>
          <button
            className={activeTab === 3 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(3)}>
            Vietnam  Office

          </button>
          <button
            className={activeTab === 4 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(4)}>
            Indonesia Office
          </button>
          <button
            className={activeTab === 5 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(5)}>
            South Korea Office
          </button>
          <button
            className={activeTab === 6 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange(6)}>
            Japan  Office
          </button>
        </div>

        <br />

        <div className="tab-content">
          {activeTab === 1 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab === 2 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}

          {activeTab === 3 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab === 4 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab === 5 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab === 6 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
        </div>
      </div>
      <br />
      <br />
      {/* <div className="heading-cnter">
        <h3>OUR GSA</h3>
      </div>
      <div className="tab-container">
        <div className="tabs">
          <button
            className={activeTab2 === 7 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange2(7)}>
            India Office
          </button>
          <button
            className={activeTab2 === 8 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange2(8)}>
            Combaodia  Office

          </button>
          <button
            className={activeTab2 === 9 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange2(9)}>
            Vietnam  Office

          </button>
          <button
            className={activeTab2 === 10 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange2(10)}>
            Indonesia Office
          </button>
          <button
            className={activeTab2 === 11 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange2(11)}>
            South Korea Office
          </button>
          <button
            className={activeTab2 === 12 ? "tab-btn active" : "tab-btn"}
            onClick={() => handleTabChange2(12)}>
            Japan  Office
          </button>
        </div>

        <br />

        <div className="tab-content">
          {activeTab2 === 7 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab2 === 8 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}

          {activeTab2 === 9 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab2 === 10 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab2 === 11 && (
            <>
              <div className='ourlocation'>
                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
          {activeTab2 === 12 && (
            <>
              <div className='ourlocation'>

                <div className='contact-details'>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-geo-alt-fill"></i>
                    </div>
                    <br />
                    <h3>Location</h3>
                    <p>55/119 Soi Phru Yai, Ratsada, Mueang Phuket District, Phuket 83000, Thailand</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-telephone-fill"></i>
                    </div>
                    <br />
                    <h3>Office Phone Number</h3>
                    <br />
                    <p>+66 934816498</p>

                  </div>
                  <div className='contact-box'>
                    <div className='icon-box'>
                      <i class="bi bi-envelope-fill"></i>
                    </div>
                    <br />
                    <h3>Mail for information</h3>
                    <br />

                    <p>B2b@expleradmc.com</p>

                  </div>
                </div>

              </div>
            </>
          )}
        </div>
      </div> */}

      <Footer />
    </>
  )
}

export default Contact